import {
    instance as axios,
    setJwtToken,
  } from '../../config/axiosInstance'
  
  // ---------------------Notification-listing--------------------------
  export const notificationListingApi = async (data) => {
    const endPoint =
      `/admin/notification` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken())
  }

//--------------------------Send Notification---------------------
export const sendNotificationApi = async (reqData) => {
    const endPoint = `http://13.203.157.210:8080/api/notification/bulk-send`
    return await axios.post(endPoint, reqData, setJwtToken())
  }

    // ---------------------Delete Notification--------------------------
    export const deleteNotificationApi = async (data) => {
      const endPoint =
        `/admin/notification/delete` + '?' + new URLSearchParams({ ...data }).toString()
      return await axios.delete(endPoint, setJwtToken())
    }
  
    // ---------------------Get Notification--------------------------
    export const getNotificationApi = async (data) => {
        const endPoint =
          `/admin/notification/admin-notification` + '?' + new URLSearchParams({ ...data }).toString()
        return await axios.get(endPoint, setJwtToken())
      }

      export const markRead = async ({notificationId}) => {
        const endPoint = `/admin/notification/read-notification` + '?' + new URLSearchParams({notificationId:notificationId}).toString()
        return await axios.get(endPoint, setJwtToken())
      }  